export function convertObjectToFormData(
    // biome-ignore lint/suspicious/noExplicitAny: this has to be any as every object can be converted to form data
    obj: any,
    formData: FormData = new FormData(),
    formDataKey = "",
    isNestedKey = false,
) {
    if (Array.isArray(obj)) {
        for (const item of obj) {
            convertObjectToFormData(item, formData, `${formDataKey}[]`, true)
        }
    } else if (typeof obj === "object") {
        for (const key of Object.keys(obj)) {
            const valueKey = isNestedKey ? `${formDataKey}[${key}]` : key
            convertObjectToFormData(obj[key], formData, valueKey, true)
        }
    } else {
        formData.append(formDataKey, obj)
    }
    return formData
}
